class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const targetDateStr = this.dataset?.targetDate;

    // If the target date is not a valid date, hide the complete timer
    if (isNaN(Date.parse(targetDateStr))) {
      this.classList.add('hidden');
      return;
    }

    this.targetDate = new Date(targetDateStr);
    this.daysElement = this.querySelector('.countdown-days');
    this.hoursElement = this.querySelector('.countdown-hours');
    this.minutesElement = this.querySelector('.countdown-minutes');
    this.secondsElement = this.querySelector('.countdown-seconds');
    this.startCountdown();
  }

  startCountdown() {
    this.interval = setInterval(() => {
      const now = new Date();
      const diff = this.targetDate - now;

      if (diff <= 0) {
        clearInterval(this.interval);
        this.classList.toggle('invisible', true);
      } else {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        this.updateDisplay(days, hours, minutes, seconds);
      }
    }, 1000);
  }

  updateDisplay(days, hours, minutes, seconds) {
    this.daysElement.textContent = days;
    this.hoursElement.textContent = hours;
    this.minutesElement.textContent = minutes;
    this.secondsElement.textContent = seconds;
  }
}

customElements.define('countdown-timer', CountdownTimer);
